import React from 'react';
import {
    Button,
    Form,
    Input,
    TextArea,
    Segment,
    Checkbox,
    Table,
    Loader,
    Popup,
    Header,
    Icon,
    HeaderSubheader
} from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { Redirect } from 'react-router-dom';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class PositionsForSystematization extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            positions: [],
            position: null,
            count: null,

            loading: true,

            data: [],
            addNewPosition: false,
            positionErr: false,
            editMode: false,
            id: null,
            optLock: null,
            systematization: null,
            back: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getPositionsForSystematization = this.getPositionsForSystematization.bind(this);
        this.addNewPosition = this.addNewPosition.bind(this);
        this.deletePosition = this.deletePosition.bind(this);
        this.edit = this.edit.bind(this);
    }

    componentWillMount() {
        this.setState({ systematization: JSON.parse(localStorage.getItem('systematization')) });

        this.getPositionsForSystematization(JSON.parse(localStorage.getItem('systematization')).id);

        axios.get('/positions')
            .then(res => {
                this.setState({
                    positions: res.data.filter(e => e.employeeType !== null).map(el => ({
                        value: el.id,
                        key: el.id,
                        text: el.name
                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch positions.');
            });
    }

    getPositionsForSystematization(orgUnitEmployeeId) {
        axios({
            method: 'get',
            url: localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' ? `systematization/positions/${orgUnitEmployeeId}/${parseInt(localStorage.getItem('orgUnitId'))}/` : `systematization/positions/${orgUnitEmployeeId}/`,
        })
            .then(res => {
                this.setState({
                    data: res.data, loading: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch positions.');
            });
    }


    addNewPosition() {
        if (!this.state.position) {
            toast('Morate unijeti poziciju.');
            this.setState({ positionErr: true });
        } else {
            this.setState({ positionErr: false });
            let obj = {
                systematization: { id: this.state.systematization.id },
                position: { id: this.state.position },
                count: this.state.count
            };

            axios.post('systematization/add-position/', { ...obj })
                .then(res => {
                    toast('Uspješno ste dodali novu poziciju.');
                    this.setState({ addNewPosition: false, position: null, count: null });
                    this.getPositionsForSystematization(this.state.systematization.id);
                })
                .catch(err => {
                    toast('Došlo je do greške. Dodavanje pozicije nije uspjelo.');
                });
        }
    }

    edit() {
        if (!this.state.position) {
            toast('Morate unijeti poziciju.');
            this.setState({ positionErr: true });
        } else {
            this.setState({ positionErr: false });

            let obj = {
                systematization: { id: this.state.systematization.id },
                position: { id: this.state.position },
                count: this.state.count,
                optLock: this.state.optLock,
                id: this.state.id
            };

            axios.put('systematization/edit-position/', { ...obj })
                .then(res => {
                    toast('Uspješno ste izmijenili poziciju.');
                    this.setState({ editMode: false, position: null, count: null });
                    this.getPositionsForSystematization(this.state.systematization.id);
                })
                .catch(err => {
                    toast('Došlo je do greške. Izmjena pozicije nije uspjela.');
                });
        }
    }

    deletePosition(id) {
        let obj = { id };
        axios.delete('systematization/delete-position/', { data: obj })
            .then(res => {
                toast('Uspješno ste obrisali poziciju.');
                this.getPositionsForSystematization(this.state.systematization.id);
            })
            .catch(err => {
                toast('Došlo je do greške. Brisanje pozicije nije uspjelo.');
            });
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    render() {
        const { systematization, editMode } = this.state;
        if (this.state.back) return <Redirect push to={{ pathname: '/sistematizacije' }} />;
        return (
            <div>
                <h1>Pozicije</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            {systematization.name}
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => this.setState({ back: true })}
                                    />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />

                            </Header>
                            <HeaderSubheader>
                                Sistematizacija
                            </HeaderSubheader>


                        </Header>
                    </Segment>
                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                    <Segment>

                            <Table celled selectable compac>
                            <Table.Header>
                                    <Table.Row>
                                    <Table.HeaderCell>Naziv pozicije</Table.HeaderCell>
                                    <Table.HeaderCell>Broj pozicija</Table.HeaderCell>
                                    {localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' &&
                                        <Table.HeaderCell as="th" verticalAlign="middle" textAlign="center">
                                            <Popup
                                                content="Dodaj poziciju"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        icon="add"
                                                        size="small"
                                                        basic="true"
                                                        color="blue"
                                                        circular
                                                        onClick={() => this.setState({ addNewPosition: true, editMode: false })}
                                                    />}
                                            />
                                        </Table.HeaderCell>}
                                </Table.Row>
                                </Table.Header>
                            {(this.state.data.length || this.state.addNewPosition) ? <Table.Body>
                                    {this.state.addNewPosition && <Table.Row>
                                    <Table.Cell>
                                            <Form noValidate>
                                            <Form.Field required error={this.state.positionErr}>
                                                    <Form.Dropdown
                                                        clearable
                                                        selection
                                                        placeholder="Odaberite poziciju"
                                                        value={this.state.position}
                                                        onChange={this.handleInputChange}
                                                        name="position"
                                                        options={this.state.positions}
                                                        search
                                                        fluid
                                                />
                                                </Form.Field>
                                        </Form>
                                        </Table.Cell>
                                    <Table.Cell>
                                            <Form>
                                            <Form.Field
                                                    control={Input}
                                                    type="number"
                                                    name="count"
                                                    value={this.state.count}
                                                    onChange={this.handleInputChange}
                                                    placeholder="Unesite broj pozicija"
                                                />
                                        </Form>
                                        </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle">
                                            <Button size="small" color="blue" icon="check" circular onClick={this.addNewPosition} />
                                            <Button
                                                size="small"
                                                color="blue"
                                                circular
                                                basic="true"
                                                icon="close"
                                                onClick={() => this.setState({
                                                    position: null, positionErr: false, editMode: false, addNewPosition: false
                                                })}
                                        />
                                        </Table.Cell>
                                    </Table.Row>}
                                    {this.state.data.map((el, index) =>
                                        (<Table.Row key={index}>
                                            <Table.Cell verticalAlign="middle">
                                                {editMode === index ?
                                                    <Form noValidate>
                                                        <Form.Field required error={this.state.positionErr}>
                                                            <Form.Dropdown
                                                                clearable
                                                                selection
                                                                placeholder="Odaberite poziciju"
                                                                value={this.state.position}
                                                                onChange={this.handleInputChange}
                                                                name="position"
                                                                options={this.state.positions}
                                                                search
                                                                fluid
                                                            />
                                                        </Form.Field>
                                                    </Form>
                                                    : el.position.name}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {editMode === index ?
                                                    <Form>
                                                        <Form.Field
                                                            control={Input}
                                                            type="number"
                                                            name="count"
                                                            value={this.state.count}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Unesite broj pozicija"
                                                        />
                                                    </Form>
                                                    : el.count}
                                            </Table.Cell>
                                            {localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' &&
                                            (editMode === index ?
                                                <Table.Cell verticalAlign="middle" textAlign="center">
                                                    <Button size="small" color="blue" icon="check" circular onClick={this.edit} />
                                                    <Button
                                                        size="small"
                                                        color="blue"
                                                        basic="true"
                                                        circular
                                                        icon="close"
                                                        onClick={() => this.setState({
                                                            position: null, positionErr: false, editMode: false, addNewPosition: false
                                                        })}
                                                    />
                                                </Table.Cell>
                                                : <Table.Cell verticalAlign="middle" textAlign="center" collapsing>
                                                    <Button
                                                        color="green"
                                                        basic="true"
                                                        size="small"
                                                        icon="pencil"
                                                        circular
                                                        onClick={() => this.setState({
                                                            editMode: index, count: el.count, optLock: el.optLock, id: el.id, position: el.position.id
                                                        })}
                                                    />
                                                    <Button
                                                        color="red"
                                                        basic="true"
                                                        size="small"
                                                        icon="trash alternate"
                                                        circular
                                                        onClick={() => this.deletePosition(el.id)}
                                                    />
                                                </Table.Cell>)}
                                        </Table.Row>
                                        ))}
                                </Table.Body> :
                                <Table.Body>
                                        <Table.Row>
                                        <Table.Cell colSpan={3}>
                                                Nema dodanih pozicija za ovu sistematizaciju.
                                            </Table.Cell>
                                    </Table.Row>
                                    </Table.Body>}
                        </Table>
                        </Segment>}
                </Segment.Group>

                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/Systematization/PositionsForSystematization.js